<template>
  <div class="row items-center">
    <ams-trim :text="props.props.row.anmerkungen" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{ props: { row: { anmerkungen?: string } } }>()
</script>
